import { useEffect } from "react";
import { useModal } from "./ModalContext";
import { isUserRegistered } from "../utils/userSession";

const ADMIN_PATH_PREFIX = "/admin";

const useGlobalClickHandler = () => {
  const { openModal, scrollGatePassed } = useModal();

  useEffect(() => {
    const handleClick = (e) => {
      const anchor = e.target.closest("a");

      if (!anchor) return;

      const href = anchor.getAttribute("href");

      if (!href || href.startsWith("http")) return;
      if (href.startsWith(ADMIN_PATH_PREFIX)) return;
      if (isUserRegistered()) return;
      if (!scrollGatePassed) return;

      e.preventDefault();
      openModal(href);
    };

    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [openModal, scrollGatePassed]);
};

export default useGlobalClickHandler;